import PlansDetailsCoupon from './PlansDetailsCoupon';

export default PlansDetailsCoupon;
